number_only_class = 'numbers-only'

init_numbers_fields = ->
  $(document).on 'keypress', ".#{number_only_class}", (event) ->
    self = $ this
    char = getChar(event)
    if char?
      event.preventDefault()  unless inArray(char, [
        "0"
        "1"
        "2"
        "3"
        "4"
        "5"
        "6"
        "7"
        "8"
        "9"
        "."
        ","
      ])
      if char is "," or char is "."
        self.val "0"  if self.val() is ""
        event.preventDefault()  if self.val().indexOf(".") > 0 or self.val().indexOf(",") > 0

  $(document).on 'change', ".#{number_only_class}", (event) ->
    self = $ this
    self.val self.val().replace(",", ".")
    current_value = self.val()
    self.val "0" + current_value  if current_value.indexOf(".") is 0
    self.val current_value + "0"  if current_value.indexOf(".") is current_value.length - 1 and current_value.length > 0